import { clsx } from 'clsx';
import styles from './SubmitButton.module.scss';

type SubmitButtonProps = {
	loading?: boolean;
	isValid?: boolean;
	action: string;
	loadingText?: string;
	onClick: () => void;
	disabled?: boolean;
	fullWidth?: boolean;
	type?: 'button' | 'submit';
};

const SubmitButton = ({
	loading,
	isValid,
	action,
	loadingText,
	onClick,
	disabled,
	fullWidth,
	type = 'submit',
}: SubmitButtonProps) => {
	const isDisabled = typeof disabled === 'boolean' ? disabled : !isValid || loading;
	const displayText = loading && loadingText ? loadingText : action;

	return (
		<button
			type={type}
			className={clsx(styles.submitButton, fullWidth && styles.fullWidth)}
			disabled={isDisabled}
			onClick={onClick}
		>
			{loading && <span className={styles.spinner} />}
			{displayText}
		</button>
	);
};

export default SubmitButton;
